// 스토어 링크와 "이 기기에 맞는 스토어" 판별.
//
// platform-service 의 getPlatform() 은 Capacitor 기준이라 웹에서는 기기가
// 아이폰이든 안드로이드든 전부 'web' 이다. 공유 링크를 브라우저로 연 사람에게
// 맞는 스토어를 보여주려면 그것과 별개로 기기 OS 를 봐야 한다.

export const APP_STORE_URL = 'https://apps.apple.com/app/id6766971258';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.voda.app';

/** 초대로 온 사람의 Play 링크 — 설치한 앱이 Play 설치 리퍼러로 코드를 받는다
 * (InstallReferrerPlugin.java → referral-service.js captureInstallReferrer). */
export function playStoreUrl(ref) {
  return ref ? `${PLAY_STORE_URL}&referrer=${encodeURIComponent(`ref=${ref}`)}` : PLAY_STORE_URL;
}

/** 브라우저에서 본 기기 OS. 'ios' | 'android' | null (데스크톱·판별 불가) */
export function mobileOS() {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  // iPadOS 13+ 는 UA 가 Macintosh 로 나온다 — 터치 지원으로 가린다.
  if (/iPad|iPhone|iPod/.test(ua)) return 'ios';
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  return null;
}

/** 홈 화면에서 띄운 PWA 인가. 이미 설치한 사람이라 스토어로 내몰지 않는다. */
export function isInstalledPWA() {
  if (typeof window === 'undefined') return false;
  try {
    return window.matchMedia?.('(display-mode: standalone)').matches
      || window.navigator.standalone === true;
  } catch {
    return false;
  }
}

/** 이 기기에 맞는 스토어 URL. 데스크톱이면 null — 배너를 띄울 이유가 없다. */
export function storeUrlForDevice() {
  const os = mobileOS();
  if (os === 'ios') return APP_STORE_URL;
  if (os === 'android') return PLAY_STORE_URL;
  return null;
}
